export default "__VITE_ASSET__BZFaSuxn__"